module.exports = __webpack_public_path__ + "static/media/18ECA39.783eb604.jpg";